// Dependencies
require("webstrap/type");
require("grid");
require("element/rich-text");
require("element/pricing");

// Styles
require("./pricing.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/pricing/index.js
 ** module id = 100
 ** module chunks = 0 1
 **/